import { bem, Chatter, selectUserId } from '@socialive/common';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Tooltip } from '../../Atoms';
import { Emoji, ExternalHyperlink } from '../../Utilities';
import './chatMessageToken.css';

/*
#tailwind
chatMessageToken__mention chatMessageToken__mention--isMe
*/

const ChatMessageToken = ({ token }) => {
  const userId = useSelector(selectUserId);

  switch (token.type) {
    case Chatter.TOKEN.CODE:
      return <span className={bem`chatMessageToken__code`}>{token.code}</span>;
    case Chatter.TOKEN.EMOJI:
    case Chatter.TOKEN.SHORTCODE:
      return <Emoji shortcode={token.shortcode} emoji={token.emoji} />;
    case Chatter.TOKEN.EMOTICON:
      return <Emoji emoticon={token.text} emoji={token.emoji} />;
    case Chatter.TOKEN.MENTION:
      return (
        <span className={bem`chatMessageToken__mention--${{ isMe: userId === token.user.userId }}`}>{token.text}</span>
      );
    case Chatter.TOKEN.NEWLINE:
      return '\n';
    case Chatter.TOKEN.ORDERED_LIST: {
      return (
        <ol className="chatMessageToken__ol">
          {token.items.map((item) => (
            <li value={item.bullet.value > 1 ? item.bullet.value : undefined} key={item.index}>
              {item.segments.map((segment) => (
                <ChatMessageToken key={segment.index} token={segment} />
              ))}
            </li>
          ))}
        </ol>
      );
    }
    case Chatter.TOKEN.SHRUG:
      return (
        <Tooltip content="/shrug">
          <span className="chatMessageToken__shrug">{token.text}</span>
        </Tooltip>
      );
    case Chatter.TOKEN.SLASH_SHRUG:
      return null;
    case Chatter.TOKEN.TEXT:
      return token.text;
    case Chatter.TOKEN.UNORDERED_LIST:
      return (
        <ul className="chatMessageToken__ul">
          {token.items.map((item) => (
            <li key={item.index}>
              {item.segments.map((segment) => (
                <ChatMessageToken key={segment.index} token={segment} />
              ))}
            </li>
          ))}
        </ul>
      );
    case Chatter.TOKEN.URL:
      return (
        <ExternalHyperlink url={token.text} className="break-all">
          {token.text}
        </ExternalHyperlink>
      );
    default:
      return null;
  }
};

ChatMessageToken.propTypes = {
  token: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(Chatter.TOKEN)).isRequired,
    text: PropTypes.string,
    shortcode: PropTypes.string,
    emoji: PropTypes.string,
    code: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    items: PropTypes.array,
    user: PropTypes.shape({
      userId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default ChatMessageToken;
